import React, {FC, PropsWithChildren} from 'react';

const AboutLayout: FC<PropsWithChildren> = ({children}) => (
  <div className="about-page__content">
    <div className="about-page__content-inner">{children}</div>
  </div>
);

export default AboutLayout;
